module.exports = __webpack_public_path__ + "img/icon_info.4a83e041.svg";